var path = 'app/scripts/modules/amazon/src/pipeline/stages/resizeAsg/resizeAsgStepLabel.html';
var html = "<span class=\"task-label\" ng-if=\"!step.context.useNameAsLabel\">\n  Resize Server Group:\n  {{step.context.serverGroupName}}\n  ({{step.context.region}})\n</span>\n<span class=\"task-label\" ng-if=\"step.context.useNameAsLabel\">\n  {{step.name}}\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/pipeline/stages/resizeAsg/resizeAsgStepLabel.html
// module id = 1230
// module chunks = 0